export default __webpack_public_path__ + "static/media/ManjuResume.90ce92ac.pdf";